import { render, staticRenderFns } from "./AddProgramModal.vue?vue&type=template&id=38f06617&scoped=true"
import script from "./AddProgramModal.vue?vue&type=script&lang=js"
export * from "./AddProgramModal.vue?vue&type=script&lang=js"
import style0 from "./AddProgramModal.vue?vue&type=style&index=0&id=38f06617&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f06617",
  null
  
)

export default component.exports